// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "v10/static/js/" + chunkId + "." + {"524":"7aa23616","653":"c3ee91c4"}[chunkId] + ".chunk.js";
};